// [CORE-485] acct.PaymentMethod.DigitalWalletId values; wallet names are brand names (not translated)
const digitalWalletNames: { [id: number]: string } = {
  1: 'Apple Pay',
  2: 'Google Pay',
  3: 'Samsung Pay'
};

export function getDigitalWalletName(digitalWalletId?: number): string | undefined {
  return digitalWalletId ? digitalWalletNames[digitalWalletId] : undefined;
}

// Text prefix for saved-card labels, e.g. "Apple Pay – Visa - ****9530"
export function digitalWalletPrefix(digitalWalletId?: number): string {
  const wallet = getDigitalWalletName(digitalWalletId);
  return wallet ? `${wallet} – ` : '';
}
